import { Box, Flex, Image } from 'pcln-design-system'
import React from 'react'
import { useMediaQuery } from 'react-responsive'
import styled, { withTheme } from 'styled-components'
import { ZIGZAG } from '../constants'
import Information from './Information'

const Wrapper = styled(Box).attrs(() => ({
  width: [4 / 5, null, 9 / 20, 1 / 2, null, 2 / 5],
  pt: [0, null, null, null, 4],
  mt: [3, null, 0],
}))``

const ImageWrapper = styled(Box).attrs(() => ({
  width: [1, null, 1 / 2],
}))``

const ZigZag = ({ content, onClick, isButtonDisplayed }) => {
  const data = content || ZIGZAG
  const isMobile = useMediaQuery({
    query: `(max-width: 39.99em)`,
  })

  return (
    <Box px={[0, null, null, null, null, 5]}>
      <Flex flexDirection='column'>
        {data.map(({ id, imageSrc, imageAlt, ...rest }) => {
          return (
            <Box key={id} px={[0, null, 4, null, null, 5]} pt={[4, null, 5]} pb={[4, null, null, null, 5]}>
              {isMobile || id % 2 === 1 ? (
                <Flex flexDirection={['column', null, 'row']}>
                  <ImageWrapper>
                    <Image width={1} src={imageSrc} alt={imageAlt} />
                  </ImageWrapper>
                  <Wrapper pl={[4, null, null, null, 5]}>
                    <Information id={id} onClick={onClick} isButtonDisplayed={isButtonDisplayed} {...rest} />
                  </Wrapper>
                </Flex>
              ) : (
                <Box>
                  <Flex
                    flexDirection={['column', null, 'row']}
                    justifyContent={['flex-start', null, 'flex-end']}
                  >
                    <Wrapper pr={[[4, null, null, null, 5]]}>
                      <Information
                        id={id}
                        onClick={onClick}
                        isButtonDisplayed={isButtonDisplayed}
                        {...rest}
                      />
                    </Wrapper>
                    <ImageWrapper>
                      <Image width={1} src={imageSrc} alt={imageAlt} />
                    </ImageWrapper>
                  </Flex>
                </Box>
              )}
            </Box>
          )
        })}
      </Flex>
    </Box>
  )
}

const ZigZagWithTheme = withTheme(ZigZag)
export { ZigZagWithTheme as ZigZag }
export default ZigZagWithTheme
